<template>
    <div  style="background:white; height:100%">
        <div class="headbar">
            <div style="width:110px">
                <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                <el-link :disabled="addBool"  @click="addRec" :underline="false" ><span style="font-size:13px; ">新增ASIN</span></el-link>
            </div>
            <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:150px; ">
                <span v-for="item in tabArr" :key='item.key'>
                    <el-option :label="item.title" v-if="item.thide=='N'" :value="item.key" style="width:150px;"></el-option>
                </span>
            </el-select>
            <el-input placeholder="请输入查询值" @keyup.enter.native="qryTabData" v-model="txtparam" size="small" style="width:380px;height:30px;   ">
                <el-button slot="append" size="small" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                <div slot="prepend">
                    <el-select v-model="oper"  size="small" style="width:110px;" >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                </div>
            </el-input>  
            <el-select v-model="selparam2"  placeholder="请选择列名" clearable size="small" style="width:150px;margin-left:5px ">
                <span v-for="item in tabArr" :key='item.key'>
                    <el-option :label="item.title" v-if="item.thide=='N'" :value="item.key" style="width:150px;"></el-option>
                </span>
            </el-select>
            <el-input placeholder="请输入查询值" @keyup.enter.native="qryTabData" v-model="txtparam2" size="small" style="width:380px; height:30px;  ">
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                <div slot="prepend">
                    <el-select v-model="oper2"  size="small" style="width:110px;" >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                </div>
            </el-input>
            <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
            <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
        </div>
        <ve-table :columns="vueCol"
                :table-data="tabData"
                :column-hidden-option="columnHiddenOption"
                :border-around="true"
                :border-x="true"
                :border-y="true"
                :fixed-header="true"
                row-key-field-name="IDSEQ"
                :row-style-option="rowStyleOption"
                :cell-style-option="cellStyleOption"
                :event-custom-option="eventCustomOption"
                :max-height="tabHeight"
                :virtual-scroll-option="virtualScrollOption"
                :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                :column-width-resize-option="columnWidthResizeOption"
                :cell-selection-option="{enable: false}"
                ref="tabref">
        </ve-table>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <div style="margin-top: 3px; overflow: hidden;display:flex;background:white">
            <div style="float: left;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="color:#606266;margin:7px 10px;font-size:12px;width:35px;">每页</div>
            <el-select v-model="rowSize" size="small" style="width:80px;"  @change="initPage">
                <el-option 
                    v-for="item in pageList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <div style="color:#606266;margin:7px 10px;margin-left:80px;font-size:12px;width:30px;">跳至</div>
            <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
            <span style="color:#606266;margin:7px 5px;font-size:12px;">页</span>
            <el-button @click="goNext" size="small" type="primary" style="width:50px;margin-left:15px;height:32px;">GO</el-button>
        </div> 
        <div class="one-toolbar">
            <span class="spanRow">
            <i class="iconfont icon-xinzeng" style="color:#fff;font-size:14px;margin-right:5px; "></i>
            <el-link :disabled="addBool" @click="addSku" :underline="false" ><span style="font-size:13px;color:white;border-bottom:1px solid white ">新增SKU</span></el-link> 
            </span>
        </div>
        <el-table  :data="dtlData" 
                border                            
                disabled-hover
                class="custom-table-border"
                :cell-style="{padding:'2px'}"
                style="overflow:auto;margin-top:1px;"
                size="small"
                height="275" 
                :row-key="getDtlKey"  
                ref="refdtl" 
                highlight-current-row>
            <el-table-column  v-for="(item,index ) in dtlArr.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.sortable=='N'"
                :min-width="item.width">
                <template  slot-scope="scope" > 
                    <el-checkbox disabled v-if="item.edcss=='checkbox'" v-model="scope.row[item.key]" true-label="Y" false-label="N"></el-checkbox>
                    <div v-else v-text="scope.row[item.key]" style="float:left"> </div>
                </template>
            </el-table-column>   
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="80">
                <template slot-scope="scope">
                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link :disabled="editBool" @click="editSku(scope.row,'N')" :underline="false"  ><span style="font-size:12px; ">编辑 </span></el-link>
                </template>
            </el-table-column>                      
        </el-table> 
        <el-dialog v-dialogDrag :visible.sync="addWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <Form ref="addForm" :model="formCol" :label-width="120"  label-position="right" inline >
                <span v-for="(item,index) in tabArr" :key="index" >
                    <FormItem :class="(item.key=='MATDESC'||item.key=='ENAME')?'item-width2':'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                        <el-input :placeholder="item.holder" :disabled="saveFlag" v-enter-number  v-if="item.edcss==='number'" v-model="formCol[item.key]" style="width:100%" ></el-input>   
                        <el-checkbox border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="formCol[item.key]" style="width:100%"></el-checkbox> 
                        <el-input :disabled="item.disabled==='Y'?true:false" type="textarea" :rows="4"  v-else-if="item.key==='MATDESC'"   v-model="formCol[item.key]"></el-input>
                        <el-select filterable @change="matChg" v-else-if="item.key==='MATNO' " v-model="formCol[item.key]"   style="width:100%">
                            <span v-for=" item  in matArr " :key="item.IDNO">
                                <el-option  :label="item.CNAME" :value="item.IDNO"></el-option>
  
                            </span>
                        </el-select>
                        <el-select :disabled="item.disabled==='Y'?true:false" v-else-if="item.edcss==='select'" v-model="formCol[item.key]"   style="width:100%">
                            <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                        </el-select>
                        <el-input v-enter-number type="text" v-else-if="item.key=='IDNO'" v-model="formCol[item.key]"></el-input>
                        <el-input :placeholder="item.holder" type="text" v-else :disabled="item.disabled==='Y'?true:false||saveFlag "  v-model="formCol[item.key]"></el-input>

                    </FormItem>
                </span>
            </Form>   

            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:50px;">取消</el-button>
                <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="modal_ok" style="margin-right:10px;">保存</el-button>
                </span>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 明细编辑 -->
        <el-dialog v-dialogDrag :visible.sync="dtlWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{dtlFlag==='create'?'新增记录':'编辑记录'}}</span>
            </div> 
            <Form  :model="dtlCol" :label-width="120"  label-position="right" inline >
                <span v-for="(item,index) in dtlArr" :key="index" >
                    <FormItem :class="(item.key=='MATDESC'||item.key=='ENAME')?'item-width2':'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'"> 
                        <el-checkbox border v-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="dtlCol[item.key]" style="width:100%"></el-checkbox> 
                        <el-input :disabled="item.disabled==='Y'?true:false" type="textarea" :rows="4"  v-else-if="item.key==='MATDESC'"   v-model="dtlCol[item.key]"></el-input>
                        <el-select filterable @change="matChg" v-else-if="item.key==='MATNO' " v-model="dtlCol[item.key]"   style="width:100%">
                            <span v-for=" item  in matArr " :key="item.IDNO">
                                <el-option  :label="item.CNAME" :value="item.IDNO"></el-option> 
                            </span>
      
                        </el-select>
                        <el-select :disabled="item.disabled==='Y'?true:false" v-else-if="item.edcss==='select'" v-model="dtlCol[item.key]"  @change="comUpdate" style="width:100%">
                            <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                        </el-select>
                        <el-input-number controls-position="right" :precision="item.dotnum" v-else-if="item.edcss=='number'" v-model="dtlCol[item.key]" style="width:100%"></el-input-number>
                        <el-input :placeholder="item.holder" type="text" v-else :disabled="item.disabled==='Y'?true:false||saveFlag "  v-model="dtlCol[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>   
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right;display:flex">
                    <span style="font-size:12px;margin-right:8px">复制SKU包装数据</span> 
                    <el-select size="small" v-model="pkseq"  @change="cpSku" style="width:200px;margin-right:20px;">
                        <el-option v-for="(item,index) in dtlData" :key="index" :label="item.SKU" :value="item.PKSEQ"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="iconfont icon-daorubiaodan"  @click="impSz" style="margin-right:50px;">导入ASIN包装数据</el-button>
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="dtlWin=false" style="margin-right:50px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="dtl_ok" style="margin-right:10px;">保存</el-button>
                </span>
            </div>
        </el-dialog>
    </div>
</template>

<script>
 
  import { getTabColOrData,getBaseData } from '../../api/user'
  import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
  import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
  export default {
    name: 'amz_skumgt',
    mixins: [
      createVeTableFieldSettingMixin({
        settingFormId: '17354',
        fieldIdseq: '17354',
        fieldLstseq: '1',
        mainColumnKey: 'tabArr',
        tableColumnKey: 'vueCol',
        initColumnKey: 'initCol',
        tableRef: 'tabref',
        generatedFixedColumnKeys: ['oper'],
      })
    ],
    components: {
      VeColumnConfigDialog,
    },
    data() {
      return {
        rowData:{},
        v_idseq:'',  
        prdArr:[],
        matArr:[],
        dtlWin:false,
        dtlFlag:'create',
        dtlCol:{},
        promptWin:false,
        prompt:'',
        addWin:false, //modal 
        formCol:{}, //表格单行记录 model
        pkseq:'',
        oper:'like',
        selparam:'ASIN',
        txtparam:'',
        oper2:'like',
        selparam2:'',
        txtparam2:'',
        comboArr:{},
        operArr:[],
        dtlData:[],
        addFlag: 'create',
        dtlArr:[],
        allData:[],
        tabData:[],
        tabArr:[],
        initCol:[],
        vueCol:[],
        columnHiddenOption: { defaultHiddenColumnKeys: [] },
        rowStyleOption: { clickHighlight: true },
        cellStyleOption: {
          bodyCellClass: ({ row }) => this.tableRowClassName({ row }),
        },
        virtualScrollOption: { enable: false },
        eventCustomOption: {
          bodyRowEvents: ({ row }) => ({ click: () => this.rowClick(row) }),
        },
        saveFlag:false,
        v_url:'xuper_auth/getTableRecMany' , //api请求路径
        addBool:false, //新增,为true时--禁止
        editBool:false, //编辑,为true时--禁止
        delBool:false, //删除 ,为true时--禁止
        cfmBool:false, //审核 ,为true时--禁止
        cancelBool:false, //作废 ,为true时--禁止 
        v_admin:this.$cookies.get('v_admin') ,//      
        v_username:this.$cookies.get('v_telno'), //api 请求用户
        
        v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
        dataCount:0,
        rowSize:1000,
        goPage:'',
        current:1,
        stfgBool:true,
        notNull:[],
        pageList: [ {
            value: 1000,
            label: '1000'
            }, {
            value: 2000,
            label: '2000'
            } 
         ],
      }
    },
    watch: {
 
    },
    created () {
        if(this.v_username){
 
            this.getTabField() // 字段集
            this.getSkuList('')  
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    mounted () {
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });
        getBaseData(this.v_url,'','','CORPID',this.v_corpid,'V_BS_MAT',' ').then(res=>{
            this.prdArr =res.result
        })
        getBaseData(this.v_url,'','','CORPID',this.v_corpid,'V_MAT_COMBO',' ').then(res=>{
            this.matArr =res.result
        })
        
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','17354','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                } 
            }
        })
        this.comSelect() 
    },
    computed:{
        tabWidth: function() {
            return (window.innerWidth - 400) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 470) + 'px';
        }, 
    },
    methods: {
        //复制sku 包装数据
        cpSku(){
            let obj ={}
            this.dtlData.some(item =>{
                if (item['PKSEQ'] ==this.pkseq){
                    obj =item
                }
            })
            Object.assign(this.dtlCol,{PKGUNIT: obj['PKGUNIT'],SALEL: obj['SALEL'] ,SALEW:obj['SALEW'],
                SALEH:obj['SALEH'],VOLUME:obj['VOLUME'],WTUNIT:obj['WTUNIT'],GROSS:obj['GROSS'],SIZEWT:obj['SIZEWT'],SKUQTY:obj['SKUQTY'] 
            })
        },
        tableRowClassName({row,rowindex}){
            if (row['ISLOCK']=='Y'){
                return 'disable-row'
            }
            return ''
        },
        comUpdate(){
            this.$forceUpdate()
        },
        impSz(){
            Object.assign(this.dtlCol,{PKGUNIT:this.rowData['PKGUNITNO'],SALEL:this.rowData['BOXL'] ,SALEW:this.rowData['BOXW'],
                SALEH:this.rowData['BOXH'],VOLUME:this.rowData['VOLUME'],WTUNIT:this.rowData['WTUNITNO'],
                GROSS:this.rowData['WT'],SIZEWT:this.rowData['SIZEWT'],SKUQTY:this.rowData['PCS'] 
            })
        },
        //明细保存
        dtl_ok(){
            this.$axios({
                method: 'post',
                url:'xuper_auth/tableBodySave',
                data: {p_json:JSON.stringify(Object.assign(this.dtlCol)), p_table:'amz_matdtl',p_idseq:this.v_idseq},
            }).then(res=>{
                this.dtlWin=false
                this.getDtlist(this.v_idseq)    
            })
        },
        matChg(val){
            this.formCol['MATNM']=''
            this.formCol['MATDESC']=''
            this.formCol['PKGUNIT']=''
            this.formCol['BOXL']=''
            this.formCol['BOXW']=''
            this.formCol['BOXH']=''
            this.formCol['VOLUME']=''
            this.formCol['WTUNIT']=''
            this.formCol['WT']=''
            this.formCol['SIZEWT']=''
            this.formCol['PCS']=''
            this.formCol['PRC']=''
            this.formCol['TAXPRC']=''
            this.formCol['MINQTY']=''
            this.prdArr.some(item=>{
                if(item['IDNO']==val){
                    this.formCol['MATNM']=item['MATNM']
                    this.formCol['MATDESC']=item['MATDESC']
                    this.formCol['PKGUNIT']=item['PKGUNIT']
                    this.formCol['BOXL']=item['BOXL']
                    this.formCol['BOXW']=item['BOXW']
                    this.formCol['BOXH']=item['BOXH']
                    this.formCol['VOLUME']=item['BOXCUBE']
                    this.formCol['WTUNIT']=item['WTUNIT']
                    this.formCol['WT']=item['NETWT']
                    this.formCol['SIZEWT']=item['GROSSWT']
                    this.formCol['PCS']=item['PCS']
                    this.formCol['PRC']=item['PRC']
                    this.formCol['TAXPRC']=item['PRC']
                    this.formCol['MINQTY']=item['STKQTY']
                }
            })
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'17354',p_cond:' and lstseq in (1,2)' ,p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        addRec(){
            this.v_idseq=''
            this.addWin =true
            this.formCol={IDSEQ:'','STFG':'Y'}
            this.addFlag='create'
        },
        addSku(){
            if (this.v_idseq){
                this.dtlWin =true
                this.dtlCol={IDSEQ:this.v_idseq,LSTSEQ:'' ,STFG:'Y' }
                this.dtlFlag='create'
            }else{
                this.prompt='请选中一条ASIN记录'
                this.promptWin =true
            }
        },
        editSku(row){
            this.dtlWin =true
            this.dtlFlag='edit'
            this.dtlCol =JSON.parse(JSON.stringify(row))
            this.pkseq =''
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.txtparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.txtparam+'\''
                }
            }
            if (this.selparam2){ //列2
                if (this.oper2==='like'){
                    cond_=cond_+' and '+this.selparam2+' like \'%' + this.txtparam2+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam2 +this.oper2+'\''+this.txtparam2+'\''
                }
            }
            this.getSkuList( cond_)
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            return row['IDSEQ']+'-'+row['LSTSEQ']
        },
        rowClick(row){
 
            this.rowData =JSON.parse(JSON.stringify(row))
            this.getDtlist(row['IDSEQ'])
            this.v_idseq =row['IDSEQ']
        },
        editRec(row,val){
            this.v_idseq =row['IDSEQ']
            this.formCol =JSON.parse(JSON.stringify(row))
            this.addWin=true 
            this.addFlag='edit' 
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promptWin=true
                this.prompt='请输入跳至页数'
            }
        },
        //ASIN
        getSkuList(cond){
            //获取所有 记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+' order by adddttm desc',p_table:'V_AMZ_MAT'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData=res.result
                    this.dtlData =[]
                    if (this.allData.length>0){
                        this.rowData =JSON.parse(JSON.stringify(this.allData[0]))
                        this.getDtlist(this.allData[0]['IDSEQ'])
                        this.v_idseq =this.allData[0]['IDSEQ']
                        // ve-table selection is handled by the row event adapter.
                    }
                    this.initPage() 
                }else{
                    this.prompt =res.result
                    this.promptWin=true  
                }
                this.$nextTick(() => {
                    const table = this.$refs.tabref
                    if (table && typeof table.refresh === 'function') table.refresh()
                })
            }) 
        },
        getDtlist(idseq){
            //获取所有 记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq', p_value:idseq, p_table:'V_AMZ_MATDTL'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.dtlData=res.result
                    if (this.dtlData.length>0){
                        this.$refs.refdtl.setCurrentRow(this.dtlData[0])
                    }
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.refdtl.doLayout();
                })
            }) 
        },
        //初始化查询页条数
        initPage(){
            // 明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
    
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.tabData = this.allData.slice(_start,_end);
        },
        //确定 保存
        modal_ok(){
            //发起保存请求   
            this.$axios({
                method: 'post',
                url:'xuper_auth/formOneSave',
                data: {p_json:JSON.stringify(Object.assign(this.formCol,{ CORPID:this.v_corpid,IDSEQ:this.v_idseq } ) ), p_table:'AMZ_MAT',p_frmid:''},
            }).then(res=>{   
                //console.log('form:'+JSON.stringify(this.formCol))      
                if(res.code ==='200')  {     
                    this.addWin =false  
                    if(this.formCol['ISLOCK']=='Y') {  //禁止时，把明细全更新为禁止
                        this.$axios({
                            method: 'post',
                            url: 'xuper_auth/updateRec',
                            data: {p_key:'idseq',p_value:this.v_idseq ,p_table:'amz_matdtl',p_cond: ' set islock=\'Y\' ' },
                        }).then(res=>{ 
                            this.getSkuList('') 
                        })
                    }else{
                        this.getSkuList('') 
                    }
                }else{
                    if (res.result.indexOf('ORA-00001')>-1){
                        this.prompt ='已存在相同的产品编码或ASIN，请核查'
                        this.promptWin=true   
                    }else{
                        this.prompt=res.result
                        this.promptWin=true
                    }
                }        
            }) 
             
        } ,
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','17354','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                vm.initCol = res.result
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.tabArr = []
                    vm.vueCol = []
                    fieldRows.forEach(item => {
                        const title = vm.$translate.getColTitle(item, vm.$store.state.lang)
                        vm.tabArr.push({
                            title,
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            edcss: item.EDCSS,
                            thide: item.THIDE,
                            holder: item.HOLDER,
                            fhide: item.FHIDE,
                            disabled: item.DISABLED,
                        })
                        if (item.THIDE !== 'N') return
                        vm.vueCol.push({
                            field: item.key,
                            key: item.key,
                            title,
                            type: item.EDCSS === 'checkbox' ? 'check' : item.EDCSS,
                            align: item.align,
                            width: Number(item.width) || (item.EDCSS === 'checkbox' ? 70 : 120),
                            sortable: item.key !== 'RN' && item.EDCSS !== 'checkbox',
                            ellipsis: { showTitle: true },
                            renderBodyCell: ({ row }) => item.EDCSS === 'checkbox'
                                ? <el-checkbox disabled true-label="Y" false-label="N" v-model={row[item.key]}></el-checkbox>
                                : row[item.key],
                        })
                    })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '操作'),
                        width: 90,
                        align: 'center',
                        fixed: 'right',
                        renderBodyCell: ({ row }) => (
                            <div>
                                <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:3px"></i>
                                <el-link disabled={vm.editBool} on-click={() => vm.editRec(row, 'N')} underline={false}><span style="font-size:12px">{vm.$LANG('1639', '编辑')}</span></el-link>
                            </div>
                        ),
                    })
                    vm.applyFieldSettingRows()
                    return res
                })
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','17354','lstseq','2','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        dotnum:res.result[k].DOTNUM,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
        }
    }
  }
</script>
<style scoped>

    .item-width  {
        width: 48%;
    } 
    .item-width2  {
        width: 97%;
    } 
.headbar{
    padding-left:2px; 
    line-height:30px;
    background:#fff;
    overflow: auto;
    padding-top:3px;
    display:flex;
    border-bottom:2px solid #389;
    height:40px;
}
 
  
.top{
        padding: 10px;
        background: rgba(0, 153, 229, .7);
        color: #fff;
        text-align: center;
        border-radius: 2px;
    }        
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .disable-row{
        color:red;
        
    }
    .el-table__body {
        width: 100%;
        // 使表格兼容safari，不错位
        table-layout: fixed !important;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{  //用于表格中checkbox disabled时为蓝色
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
